import workspace from "../../workspace";

class ShapeAbsolute {
  __shape;
  __intersectionPoints = [];
  __minLengthToIntersectionPoints;
  __absolutePos = null;
  __snappedWithShape = null;
  __snappedShapeGroup = null;

  constructor(shape) {
    this.__shape = shape;
  }
  setParentId(parentId) {
    this.__shape.shapeParent = parentId
  }
  setRotationDegreesSlab(rotationDegrees) {
    this.__shape.rotatedDegreesSlab = rotationDegrees
  }
  setAbsolutePos = (pos) => {
    this.__absolutePos = pos;
  };
  getAbsolutePosition = () => {
    return this.__absolutePos;
  };
  getIntersectionPoints = () => { return this.__intersectionPoints; };
  setIntersectionsPoints = (points) => { this.__intersectionPoints = points; };

  setSnappedWithShape = (shape) => { this.__snappedWithShape = shape}
  getSnappedWithShape = () => { return this.__snappedWithShape }

  setSnappedShapeGroup = (shapeGroup) => { this.__snappedShapeGroup = shapeGroup}
  getSnappedShapeGroup = () => { return this.__snappedShapeGroup }

  setMinLengthToIntersectionPoints = (length) => {
    this.__minLengthToIntersectionPoints = length;
  };

  import = (data) => {
    if (data.snappedWithShape && data.snappedWithShape.id) {
      const snappedWithShape = workspace.getShapeById(data.snappedWithShape.id);
      this.setSnappedWithShape(snappedWithShape);
    }

    this.setAbsolutePos(data ? data.absolutePosition : null);
    this.setIntersectionsPoints(data ? data.intersectionPoints : null);
    this.setSnappedShapeGroup(data ? data.snappedShapeGroup : null);
  }
  export = () => {
    const snappedWithShape = this.getSnappedWithShape();

    return {
      absolutePosition: this.getAbsolutePosition(),
      intersectionPoints: this.getIntersectionPoints(),
      snappedWithShape: snappedWithShape ? snappedWithShape.id : null,
      snappedShapeGroup: this.getSnappedShapeGroup(),
    }
  }
}

export default ShapeAbsolute
